<ion-app id="app" [class.shake]="isShake" [class.wave]="isWave" [class.light-theme]="isLightTheme">

  <rota-splash-screen />

  <!-- preload fonts and icons -->
  <rota-preload-resources />

  <!-- content -->
  <ion-router-outlet></ion-router-outlet>

</ion-app>